export var verticals = ['accommodation', 'banking', 'transport', 'phone'];
export var colors = [
    'blue',
    'green',
    'orange',
    'red',
    'violet',
    'white',
    'light-grey',
    'grey',
    'black',
    'pink',
    'yellow'
];
// export type TypographySizesOptions = {
//   [key in TypographySizesType]: number
// }
export var typographyColors = ['primary', 'secondary', 'light', 'extra-light', 'danger'];
export var typographyWeights = ['thin', 'light', 'regular', 'medium', 'semibold', 'bold'];
export var spacing = ['xsmall', 'small', 'medium', 'large', 'xlarge'];
// Button sizes type
export var buttonSizes = ['xxsmall', 'xsmall', 'small', 'medium', 'large', 'xlarge'];
// CircleProgress sizes type
export var circleProgressSizes = ['xsmall', 'small', 'medium', 'large'];
// Icon sizes type
export var iconSizes = ['small', 'medium', 'large', 'xlarge'];
export var themes = ['mainTheme', 'quizzesTheme'];
//# sourceMappingURL=index.js.map